var exports = {
  "kL": "x52a3aa3b--46bb46--container",
  "iE": "x52a3aa3b--46bb46--wrapper",
  "u$": "x52a3aa3b--46bb46--logotype",
  "Qq": "x52a3aa3b--46bb46--text",
  "Ot": "x52a3aa3b--46bb46--nowrap",
  "Zg": "x52a3aa3b--46bb46--emoji",
  "VN": "x52a3aa3b--46bb46--close",
};

module.exports = exports;
